import { useEffect, useState } from 'react'

import MenuIcon from 'mdi-material-ui/DotsVertical'
import { TableEdit, ImageEdit } from 'mdi-material-ui'
import Delete from 'mdi-material-ui/DeleteOutline'
import { Button, IconButton, Menu, MenuItem } from '@mui/material'

interface RowMenuProps {
  menuData: any
  icon?: JSX.Element
  label?: string
  customClass?: string
  isDisabled?: boolean
  onClose?: () => void
}

const RowMenu: React.FC<RowMenuProps> = ({
  menuData,
  icon = <MenuIcon color='secondary' />,
  label,
  customClass,
  isDisabled,
  onClose
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const parameterMenuOpen = Boolean(anchorEl)

  return (
    <>
      <div
        className={customClass}
        onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          if (Boolean(isDisabled)) return
          event.stopPropagation()
          setAnchorEl(event.currentTarget)
        }}
      >
        <IconButton
          disableRipple
          sx={{ padding: 0, opacity: isDisabled ? '0.4' : '1', cursor: isDisabled ? 'default' : 'pointer' }}
          aria-label='menu'
        >
          {Boolean(label) ? <span className='text-sm font-semibold text-coal-dark'>{label}</span> : <></>}
          {icon}
        </IconButton>
      </div>

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={parameterMenuOpen}
        sx={{
          '& .MuiMenu-paper': {
            width: 'fit-content',
            marginTop: 4,
            borderRadius: '8px',
            boxShadow: '0px 0px 10px 0px #0000001F'
          }
        }}
        onClose={() => {
          setAnchorEl(null)
          if (onClose) {
            onClose()
          }
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {menuData
          ?.filter((menuItem: any) => !Boolean(menuItem?.isHidden))
          ?.map((menuItem: any, index: number) => {
            return (
              <MenuItem
                id={menuItem.id ?? ''}
                sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
                key={`${menuItem?.itemID}_${index}`}
                disabled={menuItem?.isDisabled}
                onClick={(event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                  event.stopPropagation()
                  menuItem?.handleClick()
                  setAnchorEl(null)
                  if (onClose) {
                    onClose()
                  }
                }}
              >
                {menuItem?.component}
              </MenuItem>
            )
          })}
      </Menu>
    </>
  )
}

export default RowMenu
